import React, { useState, useEffect } from 'react'
import { useStore, useInput, useTranslate } from 'react-admin'
import TreeView from '@mui/lab/TreeView'
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@mui/material'
import { CustomTreeItem } from './customTreeItem'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import TreeItem from '@mui/lab/TreeItem'
import { cleanKey } from 'src/helper/MapperHelper'

export const MultiSelectTreeView = ({ skeleton }) => {
  // selectedNode example : contact, billing etc.
  // selectedItem example : name, email etc.
  const [selectedNode, setSelectedNode] = useState([])
  const [selectedItem, setSelectedItem] = useStore('product.treeViewSelectItem', '')
  const [expanded, setExpanded] = useState([])
  const [path, setPath] = useStore('product.path')
  const [selected, setSelected] = useStore('product.select')
  const [apiMap, setApiMap] = useStore('product.apiMap', skeleton)
  const translate = useTranslate()
  const {
    field
  } = useInput({
    source : "api_map",
    defaultValue : skeleton
  });

  let object = {}
  if (apiMap.hasOwnProperty('createReservation')) {
    object = Object.entries(apiMap.createReservation)
  }

  useEffect(() => {
    setApiMap(skeleton)
  }, [skeleton])


  const onDelete = (nodeId) => {
    setPathInObject([], nodeId)
  }

  useEffect(() => {
    if (selectedNode.length !== 0 && selectedItem.length !== 0) {
      if (path !== undefined && typeof path === 'string' && path.length >= 1) {
        let tracePath = path.split('.')
        let tracePathClean = tracePath.map((key) => {
          return cleanKey(key)
        })
        setPathInObject(tracePathClean, selectedItem)
        setSelected('') // once an item is selected in the skeleton, the item selected in the mapper will be deselected
        setPath('') // once an item is selected in the skeleton, the path will be empty
        return
      }
      if (path !== undefined && Array.isArray(path) && path.length >= 1) {
        let cleanPath = path.map((trace) => {
          return cleanKey(trace)
        })
        setPathInObject(cleanPath, selectedItem)
        setSelected('') // once an item is selected in the skeleton, the item selected in the mapper will be deselected
        setPath('') // once an item is selected in the skeleton, the path will be empty
        return
      }
    }
  }, [selectedNode, selectedItem])

  const setNodeOrItem = (nodeId) => {
    let isNode = nodeId[0].split('.')
    if (isNode.length >= 2) {
      setSelectedItem(isNode[1])
    } else {
      setSelectedNode([nodeId[0]])
    }
  }

  const handleChange = (event, nodeId) => {
    setNodeOrItem(nodeId)
  }

  const setPathInObject = (path, nodeId) => {
    if (selectedNode.length >= 1) {
      let newData = { ...apiMap }
      const nodeIdWithoutDot = nodeId.replace(/\./g, '')
      let objectToUpdate = newData.createReservation[selectedNode[0]].fields.filter(
        (item) => Object.keys(item)[0] === nodeIdWithoutDot
      )
      if (objectToUpdate !== undefined && objectToUpdate.length >= 1) {
        let nameKey = Object.keys(objectToUpdate[0])
        objectToUpdate[0][nameKey[0]] = path
        setApiMap(newData)
        field.onChange(newData)
      }
    }
  }

  const isNodeOrItem = (key, value) => {
    if (value.hasOwnProperty('isExpansible')) {
      return key
    }
    return `.${key}`
  }

  const handleSelect = (nodeId) => {
    setExpanded([nodeId])
    setSelectedItem('')
  }

  return (
    <Card className='genericTransferCard' raised={false}>
      <CardHeader title={<div className='headerTitle'>{translate('ra.message.select_option')}</div>} />
      <Divider />
      <CardContent>
        <TreeView
          aria-label='multi-select'
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          onNodeSelect={handleChange}
          expanded={expanded}
          multiSelect
        >
          {React.Children.toArray(
            Object.keys(object).length !== 0
              ? object.map((elem) => {
                  const [key, value] = elem
                  return (
                    <>
                      <TreeItem
                        nodeId={isNodeOrItem(key, value)}
                        label={key}
                        onClick={(e) => handleSelect(key)}
                      >
                        {value.hasOwnProperty('isExpansible')
                          ? React.Children.toArray(
                              value.fields.map((val) => {
                                let array_item = Object.entries(val)
                                return (
                                  <>
                                    <CustomTreeItem
                                      nodeId={isNodeOrItem(array_item[0][0], array_item[0][1])}
                                      label={`${array_item[0][0]} : [ ${array_item[0][1]} ]`}
                                      handledelete={onDelete}
                                      customClass={`
                                        ${array_item[0][1].length >= 1 ? 'assigned' : ''} 
                                        ${selectedItem.length >= 1 ? '' : 'deselected'}
                                      `}
                                    />
                                  </>
                                )
                              })
                            )
                          : null}
                      </TreeItem>
                    </>
                  )
                })
              : null
          )}
        </TreeView>
      </CardContent>
    </Card>
  )
}
